module.exports = __webpack_public_path__ + "img/slide6.c6314d83.jpg";